export default {

  // Meta
  appName: 'History of Man 2091',
  appVersion: 1,
  stateVersion: 1,

  // Bigger number makes text slower
  // This is the base number, will be impacted by user preferences
  textScrollDuration: 5,

  // CRT text on the top left will disappear after this time
  overlayTitleDelay: 6000,

  // Integers from 0 to this are used as the scale
  internalMusicVolume: 0.5,
  internalSoundVolume: 1,
  maxGlobalVolume: 5,

  // How long are notifications visible for
  notificationDelay: 5 * 1000,

  // World config
  maxMapX: 90,
  maxMapY: 90,

  maxRadioTransmissionFrequency: 140,
  minRadioTransmissionFrequency: 10

}
